import React, {useState} from 'react';
import styled from "styled-components";
import {useAuth0} from "@auth0/auth0-react";
import useFetch from "../Utilities/API/useFetch.react";
import {Button} from "react-materialize";
import {StyledTable, TableCell, TableHeader, TableRow} from "../Components/Commons/TBTable.react";


const StyledReportsPage = styled.div`
  padding-left: 4rem;
  padding-right: 4rem;
  margin-top: 8rem;
  height: 100%;
  .top-section {
    width: 100%;
    height: 15rem;
    padding-top: 3rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    
    h1 {
      color: #515151;
      font-size: 3rem;
      font-weight: 400;
      letter-spacing: 1px;
    }
  }
  
  .customers-table {
    border: 1px solid #E2E5E8;
  }
`

const StyledTextarea = styled.textarea`
border: 1px solid #E2E5E8;
margin-top: 2em;
height: 100%;
color: #515151;
`

const CustomReportsPage = () => {
  const [loading, setLoading] = useState(true);
  const [query, setQuery] = useState();
  const [reportResult, setReportResult] = useState();
  const {isLoading, isAuthenticated, user} = useAuth0();
  const [fetchUrl] = useFetch();

  const runSQL = async (report) => {
    let results = await fetchUrl("runCustomReport", {query: query})
    let trueResults = results.data
    setReportResult(trueResults)
  }



  const inferHeaders = () => {
    //Given the reportResults figure out headers
    if(reportResult && reportResult.length > 0) {
      const firstRow = reportResult[0]
      //TODO: Will they be sorted?
      return Object.keys(firstRow)
    } else {
      return []
    }

  }


  const columns = inferHeaders(reportResult)

  const inferRow = (row, index) => {
    return (<TableRow key={index} index={index}>
              {columns.map(columnKey => {
                return (<TableCell><p>{row[columnKey]}</p></TableCell>)
              })}
            </TableRow>)
  }


  return (
    <StyledReportsPage>
      <div>
        <StyledTextarea rows="10" cols="50" onChange={(ev) => {
          setQuery(ev.target.value)
        }}>
        </StyledTextarea>
      </div>
      <div>
        <Button onClick={runSQL} className={'filter-button'} node="button">Run</Button>
      </div>
      <div>
        <StyledTable>
            <TableHeader>
              {inferHeaders(reportResult).map((header) => {
                return <th>{header}</th>
              })}
            </TableHeader>
            <div>
              {
                reportResult ? reportResult.map((row, index) => {
                    return inferRow(row, index)
                  })
                  :
                  <TableRow>
                  </TableRow>
              }
            </div>
          </StyledTable>

      </div>
    </StyledReportsPage>
  )
}

export default CustomReportsPage;
